import { Interest } from '../../Interface/Response/Interest/Interest';

export const hasValue = (interest?: Interest): boolean =>
    interest?.percentage !== undefined && interest?.percentage !== '0.00';
